import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import CourseDetailHeader from "../../template/CourseDetailHeader/CourseDetailHeader";
import Load from "../../template/Load/Load";
import Video from '../../template/UtilTemplate/Vdieo';
import { apiDefine } from "../../api/web";
import { parseQuery } from "../../utils/tools";
import AXIOS from "../../api/axios";
import UA from "../../utils/ua";
import clientApi from "../../api/client";

import "./style.less";

import img1 from "../../static/images/detail/ngk/1.png";
import img2 from "../../static/images/detail/ngk/2.png";
import img3 from "../../static/images/detail/ngk/3.png";
import img4 from "../../static/images/detail/ngk/4.png";
import img5 from "../../static/images/detail/ngk/5.png";
import img6 from "../../static/images/detail/ngk/6.png";
import img7 from "../../static/images/detail/ngk/7.png";
import img8 from "../../static/images/detail/ngk/8.png";
import img9 from "../../static/images/detail/ngk/9.png";
import img10 from "../../static/images/detail/ngk/10.png";
import nasa1 from "../../static/images/detail/1.png";
import nasa2 from "../../static/images/detail/2.png";
import nasa3 from "../../static/images/detail/3.png";
import nasa4 from "../../static/images/detail/4.png";
import nasa5 from "../../static/images/detail/5.png";
import nasa6 from "../../static/images/detail/6.png";
import nasa7 from "../../static/images/detail/7.png";
import nasa_poster_0 from "../../static/images/detail/nasa_poster_1.png";
import nasa_poster_1 from "../../static/images/detail/nasa_poster_2.png";
import gif1 from '../../static/images/detail/1.gif';
import gif2 from '../../static/images/detail/2.gif';
import gif3 from '../../static/images/detail/3.gif';

const ngk_poster = "https://oss.aircourses.com/default/video/ngk1.jpg";
const queryObj = parseQuery(window.location.search.slice(1));
const ngkImg = [img1,img2,img3,img4,img5,img6,img7,img8,img9,img10];
const ngkVideo = 'https://oss.aircourses.com/default/video/ngk1.mp4';
const nasaImg = [nasa1,nasa2,nasa3,nasa4,nasa5,nasa6,nasa7];
const nasaVideo = ['https://oss.aircourses.com/default/video/nasa1.mp4','https://oss.aircourses.com/default/video/nasa2.mp4'];
const gifList = [gif1, gif2, gif3];
class CourseDetaiPage extends Component {
  constructor(props) {
    super(props);
    this.imgList = Number(queryObj.courseid)===211? nasaImg : ngkImg;
    this.videoList = nasaVideo;
    this.clientWidth =
      document.body.clientWidth || document.documentElement.clientWidth;
    this.clientHeight =
      document.body.clientHeight || document.documentElement.clientHeight;
    this.countInit = 750 / this.clientWidth;
    this.tabItem = Number(queryObj.courseid)===211
                    ?
                   [0, Math.round(5820/this.countInit)]
                   :
                   [0, Math.round(7778/this.countInit), Math.round(9884/this.countInit)]
    this.state = {
        type: Number(queryObj.courseid)===211? 'nasa' : 'ngk',
        completeRander: true,
        showVideo:true
    };
    this.timeout = [];
    this.videoRef = [];
    this.videoNgk = null;
  }

  pauseH5Media = () => {
    this.videoNgk.video.pause();
    this.videoRef.map(ele => {
      ele.video.pause();
      return false;
    })
  }

  componentDidMount() {
    apiDefine({apiName:'pauseH5Media',fn:this.pauseH5Media}); // 定义弹框回调方法
    this.timeout.push(
      setTimeout(()=>{
        clientApi.h5Message({
            data:{
                offsetHeight: this.state.type === 'nasa' ? Math.round(8650/this.countInit) : Math.round(14833/this.countInit),
                offsetWidth: this.clientWidth,
                tabItem: this.tabItem
            }
        });
      },0)
    );
    AXIOS.getCourseInfo(
        {
        data: {
            stuId: queryObj.stuid,
            channelId: queryObj.channel
        },
        query: queryObj.courseid
        },
        (res, err) => {
        if (err) alert(err.errorMessage);
        else {
            const { coverHPhoto, cnName, stuCnt, stuExpireDate, stuStatus, isPermanent } = res;
            this.setState({
                coverHPhoto,
                cnName,
                stuCnt,
                stuExpireDate,
                stuStatus,
                isPermanent
            });
        }
        }
    );
  }
  componentWillUnmount(){
    this.timeout.map(ele => (clearTimeout(ele)));
    this.setState({showVideo:false});
  }
  render() {
    const { 
      coverHPhoto, 
      cnName, 
      stuCnt, 
      stuExpireDate, 
      stuStatus, 
      type,
      showVideo,
      isPermanent
    } = this.state;
    return (
      <DocumentTitle title={'课程详情'}>
        <React.Fragment>
          {!this.state.completeRander && <Load />}
          <div className={`course_container ${type} ${ UA.mobileClient ? '' : 'pc'}`}>
              {!UA.mobileClient && (
                <CourseDetailHeader
                  title={type === 'nasa'? cnName : ''}
                  stuCount={`${stuCnt || ''}人加入学习`}
                  lessonDate={stuExpireDate || ''}
                  stuStatus={stuStatus}
                  bg={coverHPhoto}
                  isPermanent={isPermanent} // 是否永久有效
                />
              )}
              {this.imgList.map((node, index) => (
                <div className={`img_wrap img img${index}`} key={index} >
                  <img src={ node } alt="课程详情"/>
                </div>
              ))}
              {
                (showVideo && type==='ngk') && 
                  <Video 
                    src={ngkVideo}
                    className={`video ngk1`}
                    poster={ngk_poster}
                    ref={com => {this.videoNgk = com}}
                  />
              }
              {(showVideo && type==='nasa') &&
                  this.videoList.map((node, index) => (
                    <Video 
                        src={encodeURI(node)}
                        poster={index === 0 ? nasa_poster_0 : nasa_poster_1}
                        className={`video ${type}${index}`}
                        key={index}
                        ref={com => {this.videoRef[index] = com}}
                    ></Video>
                  ))
              }
              {type==='nasa' &&
                  gifList.map((node, index) => (
                    <div className={`gif_wrap gif${index}`} key={index} >
                      <img src={node} alt="gif"/>
                    </div>
                  ))
              }
          </div>
        </React.Fragment>
      </DocumentTitle>
    );
  }
}

export default CourseDetaiPage;



// WEBPACK FOOTER //
// ./src/components/courseDetailPage/CourseDetailPage.jsx